export const POWERBI = {};
POWERBI.POWERBI_MODAL_TOGGLE = "POWERBI_MODAL_TOGGLE";

